import { Dialog } from "@mui/material";
import { QuaggaComponent } from "../../../components/quagga";
import { useCallback, useEffect, useState } from "react";

export const ScannerPopover = ({
  isOpen,
  onClose,
  onScan,
}: {
  isOpen: boolean;
  onClose: () => void;
  onScan: (data: string) => void;
}) => {
  const [hasScanned, setHasScanned] = useState(false);

  const handleScan = useCallback(
    (serialNumber: string) => {
      if (hasScanned) return; // Prevent multiple scans
      setHasScanned(false);
      onClose();
      onScan(serialNumber);
    },
    [hasScanned, onClose, onScan]
  );

  useEffect(() => {
    if (isOpen && hasScanned) {
      setHasScanned(false);
    }
  }, [isOpen, hasScanned]);

  return (
    <Dialog open={isOpen} onClose={onClose}>
      { isOpen && (
        <QuaggaComponent onDetected={!hasScanned ? handleScan : undefined} />
      )}
    </Dialog>
  );
};

export default ScannerPopover;
